/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';

import { withCompatRouter, COMPAT_ROUTER_PROP_TYPES } from 'sarsaparilla/legacy';
import DetailedAvailabilityPage from './DetailedAvailabilityPage';
import DetailedAvailabilityPageNew from './DetailedAvailabilityPageNew';

import * as IDS from '../constants';

class DetailedAvailabilityConductor extends React.Component {
    static propTypes = {
        router: COMPAT_ROUTER_PROP_TYPES,
    };

    render() {
        switch (this.props.router.params.permitId) {
            case IDS.DESOLATION_GRAY_ID:
            case IDS.HELLS_CANYON_POWERBOAT_ID:
            case IDS.HELLS_CANYON_ID:
            case IDS.MAIN_SALMON_ID:
            case IDS.OLYMPIC_ID:
            case IDS.SELWAY_ID:
            case IDS.SAN_JUAN_ID:
            case IDS.SALT_ID:
            case IDS.MIDDLE_FORK_ID:
            case IDS.DESOLATION_WILDERNESS_ID:
            case IDS.CASCADES_ADVANCED_ID:
            case IDS.CASCADES_DAILY_ID:
                return <DetailedAvailabilityPageNew />;
            default:
                //Cedar Creek, Ruby Horsethief, Charon's Garden and others
                return <DetailedAvailabilityPage />;
        }
    }
}

export default withCompatRouter(DetailedAvailabilityConductor);
